import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@react-three/drei';
import { useRef, memo, useCallback, useLayoutEffect, Suspense } from 'react';
import { DoubleSide } from 'three';
const TroikaText = ({ children, color, fontSize, lineHeight, letterSpacing, textAlign, url: fontUrl, anchorX, anchorY, fontFamily, visible = true, curvature = 0, alpha, position, maxWidth, depthWrite, renderOrder, onPointerOver, onPointerOut, side = DoubleSide, curveRadius = 0, preventPolygonOffset = false, raycast, onTextSync }) => {
    const meshRef = useRef(undefined);
    useLayoutEffect(() => {
        if (!meshRef.current)
            return;
        const material = meshRef.current.material;
        material.depthWrite = false;
        material.side = side;
    }, [meshRef, side]);
    const _onSync = useCallback(() => {
        if (!meshRef?.current?.textRenderInfo || !onTextSync)
            return;
        //console.log('text render info from mesh', meshRef.current.textRenderInfo);
        const { blockBounds } = meshRef.current.textRenderInfo;
        onTextSync?.(blockBounds);
    }, [onTextSync]);
    if (fontSize === 0)
        return null;
    return (_jsx("group", { children: _jsx(Suspense, { fallback: null, children: _jsx(Text, { raycast: raycast, ref: meshRef, color: color, position: position, fontSize: fontSize, lineHeight: lineHeight, letterSpacing: letterSpacing, textAlign: textAlign, font: fontUrl, maxWidth: maxWidth, anchorX: anchorX, 
                // @ts-expect-error drei text types don't include % though they do work
                anchorY: fontFamily?.toLowerCase().includes('roboto') ? '42%' : anchorY, "material-opacity": alpha, "material-transparent": true, "material-depthWrite": depthWrite, renderOrder: (renderOrder || 0) + 2, onPointerOver: onPointerOver, onPointerOut: onPointerOut, onSync: _onSync, visible: visible, 
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                curveRadius: curveRadius, depthOffset: curvature !== 0 && !preventPolygonOffset ? -750 : 0, children: children }) }) }));
};
TroikaText.displayName = 'Text';
export default memo(TroikaText);
